<template>
  <v-row no-gutters>
    <v-col cols="12" class="mb-2">
      <v-card class="factoring">
        <v-card-title class="font-size--16">오늘 입금 예정</v-card-title>
        <v-card-text>
          <table>
            <tr>
              <td class="font-size--16">선정산</td>
              <td class="money font-size--16">{{ factoringAmount | commaFormat }} 원</td>
            </tr>
            <tr>
              <td class="font-size--16">카드사 직접지급</td>
              <td class="money font-size--16">{{ byPass | commaFormat }} 원</td>
            </tr>
            <tr>
              <td class="font-size--16">수수료 차액</td>
              <td class="money font-size--16">{{ feeDiff | commaFormat }} 원</td>
            </tr>
            <tr>
              <td class="cancel font-size--16">(-) 매출 취소</td>
              <td class="cancel money font-size--16">
                <span v-if="cardCanceled > 0"> - </span>
                {{ cardCanceled | commaFormat }} 원
              </td>
            </tr>
            <tr>
              <td class="cancel">
                <p class="ma-0 font-size--15">
                  <span class="font-size--16">(-)</span> 번개입금 서비스 이용료
                </p>
              </td>
              <td class="cancel money font-size--16">
                <span v-if="sumCost > 0"> - </span>
                {{ sumCost | commaFormat }} 원
              </td>
            </tr>
            <tr>
              <td class="font--m-4 font-weight-black">합계</td>
              <td class="money font--m-4 font-weight-black">
                {{ totalTransfer | commaFormat }} 원
              </td>
            </tr>
          </table>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12">
      <v-card class="refund">
        <v-card-title class="font-size--16 px-0">지급 내역</v-card-title>
        <v-card-text>
          <table>
            <tr v-for="(refund, i) in refunds" :key="i">
              <td>
                {{ refund.created | datetimeFormat }}
              </td>
              <td class="payments_money">{{ refund.amount | commaFormat }}원</td>
            </tr>
          </table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    date: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      repaymentsSimple: {},
      sumCost: 0,
    }
  },
  computed: {
    ...mapGetters('earlyPayment', {
      isLoading1: 'getEarlyPaymentsLoading',
      isLoading2: 'getRefundsLoading',
      earlypayments: 'getEarlyPayments',
      refunds: 'getRefunds',
    }),
    isLoading() {
      return this.isLoading1 || this.isLoading2
    },
    factoringAmount() {
      return this.earlypayments?.amount ?? 0
    },
    byPass() {
      return this.earlypayments?.byPass ?? 0
    },
    feeDiff() {
      return this.earlypayments?.feeDifference ?? 0
    },
    cardCanceled() {
      return this.earlypayments?.canceled ?? 0
    },
    totalTransfer() {
      const transfer = this.earlypayments?.totalTransfer ?? 0
      const cost = this.sumCost
      return Math.max(transfer - cost, 0)
    },
  },
  watch: {
    date: {
      immediate: true,
      handler(newValue) {
        this.getData(newValue)
      },
    },
  },
  methods: {
    ...mapActions('earlyPayment', ['getEarlyPayments', 'getRefunds']),
    ...mapActions('loan', ['getRepaymentsSimple']),
    getData(date) {
      if (!date) {
        return
      }
      this.getEarlyPayments(date)
      this.getRefunds(date)
      this.fetchRpy(date)
    },
    async fetchRpy(date) {
      if (!!this.repaymentsSimple?.[date]) {
        return
      }

      const rpy = await this.getRepaymentsSimple(date)
      this.repaymentsSimple[date] = rpy

      if (date == this.date) {
        let result = 0
        this.repaymentsSimple[date].forEach(
          (rpy) => (result += rpy.fee + rpy.interest + rpy.overdueInterest),
        )
        this.sumCost = result
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.factoring {
  width: 100%;

  table {
    width: 100%;
    tr {
      td {
        width: 50%;
        padding-bottom: 4px;
      }

      .money {
        text-align: right;
      }

      .cancel {
        color: #a0a0a0;
      }
    }
  }
}

.refund {
  width: 100%;
  box-shadow: none !important;

  padding: 0 8px;

  table {
    width: 100%;
    tr {
      td {
        width: 70%;
        font-size: 12px;
      }
      .payments_money {
        width: 30%;
        text-align: right;
        font-size: 12px;
        color: #14afff;
      }
    }
  }
}
</style>
